export default __webpack_public_path__ + "static/media/light_bulb.6a77c993.svg";